<template>
  <div class="columns is-multiline">
    <div class="column">

      <div class="btn-group-justify-end">
        <div class="button is-primary">저장하기</div>
      </div>

      <div class="box">
        <admin-box-item title="메뉴 수정" :useTab="false">

          <div class="flex" style="border-bottom: 2px solid #dbdbdb;">
            <div class="lp-menu-title" style="text-align: center">메뉴명</div>
            <div class="lp-menu-desc" style="text-align: center">페이지 타이틀명(존재하는 페이지일 경우만 수정 가능)</div>
          </div>

          <!-- 1차 -->
          <div v-for="menu in menus" :key="menu.name">
            <div class="flex">
              <div class="lp-menu-title">
                <input class="input"
                       type="text"
                       :value="menu.name"
                       @input="e => menu.name = e.target.value"></div>
              <div class="lp-menu-desc">
                <input class="input"
                       type="text"
                       :value="menu.desc"
                       @input="e => menu.desc = e.target.value"
                       v-if="menu.path"></div>
            </div>
            <!-- 2차 -->
            <div v-for="child in menu.child" :key="child.name">
              <div class="flex">
                <div class="lp-menu-title">
                  <input class="input"
                         type="text"
                         :value="child.name"
                         @input="e => child.name = e.target.value">
                </div>
                <div class="lp-menu-desc">
                  <input class="input"
                         type="text"
                         :value="child.desc"
                         @input="e => child.desc = e.target.value"
                         v-if="child.path"></div>
              </div>
              <!-- 3차 -->
              <div v-for="gchild in child.child" :key="gchild.name">
                <div class="flex">
                  <div class="lp-menu-title">
                    <input class="input"
                           type="text"
                           :value="gchild.name"
                           @input="e => gchild.name = e.target.value"></div>
                  <div class="lp-menu-desc">
                    <input class="input"
                           type="text"
                           :value="gchild.desc"
                           @input="e => gchild.desc = e.target.value"
                           v-if="gchild.path"></div>
                </div>
                <!-- 4차 -->
                <div v-for="ggchild in gchild.child" :key="ggchild.name">
                  <div class="flex">
                    <div class="lp-menu-title">
                      <input class="input"
                             type="text"
                             :value="ggchild.name"
                             @input="e => ggchild.name = e.target.value">
                    </div>
                    <div class="lp-menu-desc">
                      <input class="input"
                             type="text"
                             :value="ggchild.desc"
                             @input="e => ggchild.desc = e.target.value"
                             v-if="ggchild.path"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </admin-box-item>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    components: {

    },
    created() {
      if(this.$store.getters.menus){
        this.menus = this.cloneItem(this.$store.getters.menus);
      }
    },
    computed:{
    },
    data() {
      return {
        menus: [],
      }
    },
    methods: {
      saveData(){
        // this.$axios.patch(this.getUrl())
      }
    }
  }
</script>

<style type="styl" lang="stylus" scoped>
  //@import '~assets/css/lp_main'

  .lp-menu-title
  .lp-menu-desc
    padding 4px

  .lp-menu-title
    width 20%

  .lp-menu-desc
    width 80%

</style>
